// super simple global item cache
// pretty hacky way to store results from simc-items API that can be re-used by SimcInput.toCharacter
const cache = {};

export default {
  update: (item) => {
    const id = parseInt(item.id, 10);
    cache[id] = item;
  },
  get: (rawId) => {
    const id = parseInt(rawId, 10);
    return cache[id];
  },
};
